export default __webpack_public_path__ + "static/media/avatar_133.61b2847a.png";